import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as Colors from 'material-ui/styles/colors';
import {
  Table, search, sort, highlight, resolve,
  SearchColumns, resizableColumn, Provider
} from 'reactabular-table';
import transitions from 'material-ui/styles/transitions';
import {connect} from 'react-redux';
import VirtualizedListView, {ROW_HEIGHT} from 'shared/components/VirtualizedListView/VirtualizedListView';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {getResizeUrl} from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
import ChildrenFader from 'shared/components/ChildrenFader';
import {getTemplatesBySelectedTag} from 'shared/selectors/templatesSelectors';
import EyeIcon from 'material-ui/svg-icons/image/remove-red-eye';
const tableStyles = require('shared/components/TableHelpers/TableStyles.scss');
import { EDITOR_MODES } from 'crazyEditor/core/constants/editorConstants';
import * as routes from 'App/routeConstants';
import { Link } from 'react-router';
import _ from 'lodash';
import NoTemplatesInFolder from 'MyAccount/ViewTemplates/containers/NoTemplatesInFolder';
import NoSavedTemplates from 'MyAccount/ViewTemplates/containers/NoSavedTemplates';
import InlineButton from 'shared/components/InlineButton';
import {TABS} from 'MyAccount/ViewDesigns/consts';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

@connectWithRouter(
  state => ({
    query: state.routing.location.query,
    pathname: state.routing.location.pathname,
    templatesBySelectedTag: getTemplatesBySelectedTag(state),
    selectedTag: state.routing.location.query.selectedTag,
    userTemplates: state.templates.userTemplates,
    userTags: state.user.tags,
  }),
)
export default class ListView extends Component {
  columns = [
    {
      property: 'previewUrl',
      props: {
      },
      header: {
        label: 'Thumbnail'
      },
      cell: {
        formatters: [value => {
          return (
            <div
              style={{marginLeft: 24, backgroundImage: `url(${getResizeUrl(value, {width: 50})})`}}
              className={tableStyles.thumbImg}
            />
          );
        }],
      }
    },
    {
      property: 'name',
      props: {
        style: {
          flexGrow: 1,
          flexShrink: 1,
          marginLeft: 55,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'flex-start',
          minWidth: 0,
          width: 0,
        }
      },
      header: {
        label: 'Data'
      },
      cell: {
        formatters: [(name, {rowData: {id}}, hovered) => {
          const {query} = this.props;
          return (
            <div style={{display: 'flex', width: '100%', height: '100%'}}>
              <div style={{display: 'flex', width: '100%', height: '100%', justifyContent: 'space-between', alignItems: 'center', paddingRight: 30}}>
                <div
                  style={{
                    width: 0,
                    flexGrow: 1,
                  }}
                >
                  <div
                    key="1"
                    style={{
                      fontSize: 18,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      width: '100%',
                    }}
                  >
                    {name}
                  </div>
                </div>
                <ChildrenFader
                  onClick = {e => e.stopPropagation()}
                  visible = {hovered}
                  transitionDurationMs={75}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <FlatButton
                    style={{marginRight: 20}}
                    icon = {<EyeIcon/>}
                    label = "view"
                    containerElement={<Link to={{pathname: routes.Editor.TemplateURL, query: {...query, id: id, mode: EDITOR_MODES.QUICK_PREVIEW}}} />}
                  />
                  <RaisedButton
                    label = "select"
                    containerElement={<Link to={{pathname: routes.Editor.TemplateURL, query: {...query, id: id}}} />}
                  />
                </ChildrenFader>
              </div>
            </div>
          );
        }],
      },
    },
  ];

  render() {
    const {onChangeTab, selectedTag, templatesBySelectedTag, userTags, userTemplates, ...other} = this.props;
    if (templatesBySelectedTag === null) {
      return null;
    }
    const noTemplates = userTags && _.keys(userTags).length === 0 && userTemplates[0].length === 0 && selectedTag === 'Home';
    if (noTemplates) {
      return (<NoSavedTemplates>Start designing your listing with one of our professionally design <InlineButton onClick={() => onChangeTab(TABS.THEMES)}>THEMES</InlineButton></NoSavedTemplates>);
    }
    if (_.isEmpty(templatesBySelectedTag)) {
      return <NoTemplatesInFolder>Please select a different folder.</NoTemplatesInFolder>;
    }
    return (<VirtualizedListView
      key = {selectedTag}
      filterFields = {['name']}
      sortFields={[
        {
          label: 'Last Modified',
          iteratees: ({modifiedAt}) => modifiedAt || '0',
        },
        {
          label: 'Name',
          iteratees: ({name}) => name.toLowerCase().trim(),
        }
      ]}
      columns = {this.columns}
      items = {templatesBySelectedTag}
      {...other}
    />);
  }
}